import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { List } from 'immutable';
import { Store } from '@ngrx/store';
import {
  job,
  estimate,
  jobPortalData,
  jobs,
  preview,
  estimateNumberApproved,
  note,
  noteLoading,
} from './job-data.reducer';
import { Job } from './job.model';
import { filter, map, take } from 'rxjs/operators';
import { JobPortalData } from './models/job-portal-data.model';
import { JobEstimate } from './models/submodels/job-estimate.model';
import { Attachments } from './models/submodels/attachments.model';
import { JobNote } from './models/submodels/job-note.model';

@Injectable()
export class JobDataStore {
  jobs$: Observable<List<Job>> = this._store.select(jobs);
  job$: Observable<Job> = this._store.select(job);
  jobPortalData$: Observable<JobPortalData> = this._store.select(jobPortalData);
  estimate$: Observable<JobEstimate> = this._store.select(estimate);
  preview$: Observable<JobEstimate | Attachments> = this._store.select(preview);
  estimateNumberApproved$: Observable<string> = this._store.select(
    estimateNumberApproved
  );
  note$: Observable<JobNote> = this._store.select(note);
  noteLoading$: Observable<boolean> = this._store.select(noteLoading);

  constructor(private _store: Store<any>) {}

  getJobs(): Observable<List<Job>> {
    return this.jobs$.pipe(
      filter((x) => !!x),
      take(1)
    );
  }

  getJob(): Observable<Job> {
    return this.job$.pipe(
      filter((x) => !!x),
      take(1)
    );
  }

  getJobPortalData(): Observable<JobPortalData> {
    return this.jobPortalData$.pipe(filter((x) => !!x));
  }

  getEstimate(): Observable<JobEstimate> {
    return this.estimate$.pipe(
      filter((x) => !!x),
      take(1)
    );
  }

  preview(): Observable<JobEstimate | Attachments> {
    return this.preview$.pipe(filter((x) => !!x));
  }

  getNote(): Observable<JobNote> {
    return this.note$.pipe(filter((x) => !!x));
  }

  getNoteLoading(): Observable<boolean> {
    return this.noteLoading$.pipe(filter((loading) => loading !== null));
  }
}
